// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getErrorMessage(error: any): string {
  return (
    error?.data?.message ||
    error?.response?.data?.message ||
    error?.message ||
    error?.error?.message ||
    error
  );
}
